import { MAX_FILE_SIZE } from '@constants/pdf.constants';
import { DocumentJobError } from '@domain/types';
import { DocumentProcessingController } from '@launcher/context/DocumentProcessing.context';
import { registerPendingImport } from '@services/analytics/fileImportCompletedTracker';
import { uploadTrackingContextFromJob } from '@services/analytics/uploadAnalytics';
import { legacyFeatureFlagsStore } from '@services/featureFlags/legacyFeatureFlags.store';
import { HttpError } from '@services/http/http.error.service';

import { UploadDocumentsActions } from '../uploadDocuments.slice';

export const documentProcessingMiddleware = (_store: any) => (next: any) => (action: any) => {
  const result = next(action);

  const useNewUploadUI = legacyFeatureFlagsStore.get()['enable-new-import-analyze-flow'];

  if (!useNewUploadUI) {
    return result;
  }

  switch (action.type) {
    case UploadDocumentsActions.addUploadJob.type: {
      const { payload } = action;
      const file = {
        uid: payload.fileStorageId,
        name: payload.fileName,
      };
      DocumentProcessingController.addDocuments([file as any]);
      break;
    }

    case UploadDocumentsActions.jobUploadProcess.type: {
      const { payload } = action;
      DocumentProcessingController.updateStatus(payload.job.fileStorageId, 'UPLOADING');
      break;
    }

    case UploadDocumentsActions.jobUploadSuccess.type: {
      const { payload } = action;
      DocumentProcessingController.replaceId(payload.job.fileStorageId, payload.documentId);
      DocumentProcessingController.updateStatus(payload.documentId, 'ANALYZING');
      registerPendingImport(payload.documentId, uploadTrackingContextFromJob(payload.job));
      break;
    }

    case UploadDocumentsActions.jobUploadFailure.type: {
      const { payload } = action;
      const errorCode = payload.errors[0] || 'DEFAULT';
      const rawError = payload.error;

      const error: {
        code: string;
        params?: Record<string, string | number>;
        httpDetails?: { statusCode?: number; message?: string; response?: unknown };
      } = { code: errorCode };

      if (errorCode === DocumentJobError.FileSizeTooBig) {
        error.params = { size: MAX_FILE_SIZE };
      }

      if (rawError instanceof HttpError) {
        error.httpDetails = {
          statusCode: rawError.statusCode,
          message: rawError.message,
          response: rawError.response,
        };
      } else if (rawError instanceof Error) {
        error.httpDetails = { message: rawError.message };
      }

      DocumentProcessingController.updateStatus(payload.job.fileStorageId, 'FAILURE', error);
      break;
    }

    default:
      break;
  }

  return result;
};
